module.exports = __webpack_public_path__ + "static/media/feature_købispil.681b153f.jpg";